module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "basic-pagination"
  }, [_c('ui-button', {
    attrs: {
      "color": "default",
      "type": "normal",
      "icon": "keyboard_arrow_left",
      "disabled": _vm.meta.current_page <= 1
    },
    on: {
      "click": function($event) {
        _vm.setPage(_vm.meta.current_page - 1)
      }
    }
  }), _vm._v(" Strona: "), _c('span', [_vm._v(_vm._s(_vm.meta.current_page))]), _vm._v(" / "), _c('span', [_vm._v(_vm._s(_vm.meta.last_page))]), _vm._v(" "), _c('ui-button', {
    attrs: {
      "color": "default",
      "type": "normal",
      "icon": "keyboard_arrow_right",
      "disabled": _vm.meta.current_page >= _vm.meta.last_page
    },
    on: {
      "click": function($event) {
        _vm.setPage(_vm.meta.current_page + 1)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Rekordów: " + _vm._s(_vm.meta.total))]), _vm._v(" "), _c('select', {
    attrs: {
      "name": "limit"
    },
    on: {
      "change": _vm.setLimit
    }
  }, _vm._l((_vm.meta.limits), function(l) {
    return _c('option', [_vm._v("\n        " + _vm._s(l) + "\n      ")])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fb81835","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pagination/Basic.vue
// module id = 240
// module chunks = 0